/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWebm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586v3.44h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m8.4 15.682.704-2.425H9.8l.731 2.395.553-2.611h.831l-.868 3.922h-.81l-.804-2.64-.76 2.64h-.81l-.868-3.922h.852zm6.543-1.929h-1.71v.874h1.554v.712h-1.554v.912h1.764v.712h-2.605V13.04h2.551zm2.038-.712c.5 0 .867.084 1.101.253.237.169.355.432.355.788a.846.846 0 0 1-.296.658 1.12 1.12 0 0 1-.229.153c.151.046.278.112.38.198.208.169.312.41.312.723 0 .384-.13.672-.393.863-.263.19-.662.286-1.197.286h-1.408V13.04zm-.567 3.274h.534c.277 0 .481-.043.61-.13.13-.086.195-.22.195-.404 0-.18-.065-.31-.194-.393-.13-.083-.334-.124-.61-.124h-.535zm0-1.65h.41c.284 0 .485-.036.6-.108.118-.076.178-.202.178-.378a.501.501 0 0 0-.076-.291.407.407 0 0 0-.243-.157 1.717 1.717 0 0 0-.459-.048h-.41zm4.843.96 1.228-2.584h.88v3.922h-.83v-2.541l-1.037 2.163h-.518l-1.036-2.129v2.507h-.814V13.04h.88z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileWebm as FileWebm };
